/* Landing lc-*: galería, cuenta regresiva y botones que llevan al formulario COD */
(function(){
  if (window.__lcLanding) return; window.__lcLanding = true;

  function initGallery(root){
    if (root.dataset.lcReady) return; root.dataset.lcReady = '1';
    var slides = root.querySelectorAll('[data-lc-slide]');
    var thumbs = root.querySelectorAll('[data-lc-thumb]');
    var i = 0;
    function go(n){
      i = (n + slides.length) % slides.length;
      slides.forEach(function(s,k){ s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function(t,k){ t.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function(t,k){ t.addEventListener('click', function(){ go(k); }); });
    var p = root.querySelector('[data-lc-prev]'), n = root.querySelector('[data-lc-next]');
    if (p) p.addEventListener('click', function(){ go(i-1); });
    if (n) n.addEventListener('click', function(){ go(i+1); });
    var x0 = null;
    root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    root.addEventListener('touchend', function(e){
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i+1 : i-1);
    }, {passive:true});
  }

  function initCountdown(el){
    if (el.dataset.lcReady) return; el.dataset.lcReady = '1';
    var h = el.querySelector('[data-lc-t="h"]'), m = el.querySelector('[data-lc-t="m"]'), s = el.querySelector('[data-lc-t="s"]');
    function pad(v){ return v < 10 ? '0' + v : '' + v; }
    function tick(){
      var now = new Date(), end = new Date(now); end.setHours(23,59,59,999);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = pad(Math.floor(d / 3600)); m.textContent = pad(Math.floor(d % 3600 / 60)); s.textContent = pad(d % 60);
    }
    tick(); setInterval(tick, 1000);
  }

  /* Los CTA del cuerpo abren el popup de Easy Sell; si no está, bajan a los packs del hero */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-lc-cta]');
    if (!b) return;
    e.preventDefault();
    var pop = document.querySelector('#es-popup-button');
    if (pop) { pop.click(); return; }
    var t = document.querySelector('#easysell-embedded-offers') || document.querySelector('#lc-buy');
    if (t) t.scrollIntoView({behavior:'smooth', block:'center'});
  });

  function boot(){
    document.querySelectorAll('[data-lc-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-lc-countdown]').forEach(initCountdown);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
